import { Appearance } from 'react-native'
import Config from 'APP/Config'
import { type SupportedStyle } from 'APP/Models/Style'
import { isWeb } from './checkPlatform'

export const ColourScheme = {
  DARK: 'dark' as const,
  LIGHT: 'light' as const,
} as const

/**
 * Gets the current preferred colour scheme from the active environment.
 *
 * - Web, this will always be LIGHT
 * - Native, we check for a configured scheme (Config.APP_COLOUR_SCHEME) which allows
 * up to "hardcode" the scheme for an environment, OR as a fallback, we get the
 * colour scheme from the device preferences via Appearance.getColorScheme.
 * Anything other than dark (including an unset device preference) resolves to LIGHT.
 */
export function getColourScheme(): SupportedStyle {
  if (isWeb()) return ColourScheme.LIGHT

  const scheme = Config.APP_COLOUR_SCHEME || Appearance.getColorScheme()
  return scheme === ColourScheme.DARK ? ColourScheme.DARK : ColourScheme.LIGHT
}

// TODO: Move over addChangeListener as well
